import { render, staticRenderFns } from "./ComplaintHistory.vue?vue&type=template&id=2898d1ce&"
import script from "./ComplaintHistory.vue?vue&type=script&lang=js&"
export * from "./ComplaintHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports